<template>
  <ZNavigationDrawer
    mini
    :router="router as any"
    :permissions="permissions"
    home="/"
    :rounded-overlay="true"
    :drawer-button="true"
  >
    <template #appendButton="{ open }">
      <v-tooltip>
        <template #activator="{ props: activatorProps }">
          <v-btn
            :color="isDev ? 'info' : undefined"
            variant="tonal"
            class="ma-2"
            v-bind="activatorProps"
            :icon="!open"
            :size="!open ? 'small' : 'default'"
          >
            <v-icon>mdi-information-outline</v-icon
            ><span v-if="open" class="ml-3">{{ appVersion }}</span>
          </v-btn>
        </template>
        <p>
          version: {{ appVersion }}<span v-if="compilationDateStr">-{{ compilationDateStr }}</span>
        </p>
        <p v-if="region">Region: {{ region }}</p>
      </v-tooltip>
    </template>
  </ZNavigationDrawer>
</template>

<script setup lang="ts">
import router from '@/router'
import { daisukeAuth0Store } from '@tsyl/daisuke-auth-plugin'
import settings from '@/settings'
import { getDateString } from '@/utils/dateUtils'

const daisuke = daisukeAuth0Store()
const permissions = (v: string): boolean => daisuke.hasPermission(v) ?? false

const isDev = settings.ENVIRONMENT !== 'production'
const appVersion = process.env.appVersion
const region = process.env.VITE_TARGET
const compilationDateStr = getDateString(process.env.buildDate ?? '', 'UTC', 'yyMMdd.HHmm')
</script>
